import { setContext } from "@apollo/client/link/context";
import { from } from "@apollo/client/core";

export default defineNuxtPlugin(() => {
	const nuxtApp = useNuxtApp();
	const config = useRuntimeConfig();

	if (import.meta.server) {
		if (!config.hostApiServer) {
			throw new Error("Missing required env var: NUXT_HOST_API_SERVER");
		}

		if (!config.public.hostApiClient) {
			throw new Error("Missing required env var: NUXT_PUBLIC_HOST_API_CLIENT");
		}
	}

	const client = nuxtApp.$apollo.defaultClient;

	const runtimeEndpointLink = setContext((_, previousContext) => ({
		...previousContext,
		uri: import.meta.server
			? `${config.hostApiServer}/graphql`
			: `${config.public.hostApiClient}/graphql`,
	}));

	// Prepend link — existing auth/error links are preserved.
	// setLink() must be used (not direct assignment) to update queryManager.link,
	// which is what Apollo actually uses to execute operations.
	client.setLink(from([runtimeEndpointLink, client.link]));
});
